// Keep workspace glass neutral across account colors. Brand colors belong to
// actions and accents; the shared material provides a small elevation change.
export const darkSurfaces = {
  canvas: '#151817',
  panel: '#212523',
  glass: 'rgba(33,37,35,0.96)',
  inset: '#1D211F',
  hover: '#2A2F2C',
  rim: 'rgba(255,255,255,0.09)',
  highlight: 'rgba(255,255,255,0.025)',
  sheen: 'linear-gradient(150deg, rgba(255,255,255,0.025), transparent 55%)',
  header: 'linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.005))',
};

export const darkSurfaceCssVars = Object.fromEntries(
  Object.entries(darkSurfaces).map(([key, value]) => [`--node-dark-${key}`, value])
);
